import { render, staticRenderFns } from "./WhoBlock.vue?vue&type=template&id=63834950"
import script from "./WhoBlock.vue?vue&type=script&lang=js"
export * from "./WhoBlock.vue?vue&type=script&lang=js"
import style0 from "./WhoBlock.vue?vue&type=style&index=0&id=63834950&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports